import React from "react";
import { Box, SxProps, Theme } from "@mui/material";

// Where a stone's price sits among comparable stones, from its price percentile: ● in the middle
// (40–60), + to +++ above, - to --- below, colored from orange to dark red the further out it is.
const pricingMark = (percentile: number) => {
  if (percentile >= 40 && percentile <= 60)
    return { symbol: "●", color: "green" };
  if (percentile > 90) return { symbol: "+++", color: "#B00" };
  if (percentile > 75) return { symbol: "++", color: "#F00" };
  if (percentile > 60) return { symbol: "+", color: "orange" };
  if (percentile < 10) return { symbol: "---", color: "#B00" };
  if (percentile < 25) return { symbol: "--", color: "#F00" };
  return { symbol: "-", color: "orange" };
};

// The mark itself, as the grids' Pricing column and the diamond header show it. Nothing when the
// stone has no percentile.
const PricingMark = ({
  percentile,
  sx,
}: {
  percentile?: number | null;
  sx?: SxProps<Theme>;
}) => {
  if (!percentile) return null;
  const { symbol, color } = pricingMark(percentile);
  return <Box sx={{ color, fontSize: "150%", ...sx }}>{symbol}</Box>;
};

export default PricingMark;
